export default __webpack_public_path__ + "static/media/approval-bg-small.5e17044c.jpg";